export default __webpack_public_path__ + "1115eb440b4bf08173f97ce29bdb9f7b.png";